import { useAtomValue } from 'jotai';
import { useCallback, useState } from 'react';

import { EndSessionButton } from '../../components/EndSessionButton';
import { TrackingEvents, sendLoggingEvents } from '../../events';
import { isRestartingSessionAtom } from '../state';
import { EarlyEndSessionModal } from './EarlyEndSessionModal';
import { useHandleCompleteSessionCallbacks } from './useHandleCompleteSessionCallbacks';

export function CompleteSessionButton() {
  const [isEarlyEndModalOpen, setIsEarlyEndModalOpen] = useState(false);
  const { checkShouldShowEarlyEndModal, handleCompleteSession, handleRestartSession, handleCompleteSessionEarly } =
    useHandleCompleteSessionCallbacks();
  const isRestartLoading = useAtomValue(isRestartingSessionAtom);

  const handleButtonPress = useCallback(() => {
    const shouldShowModal = checkShouldShowEarlyEndModal();
    if (shouldShowModal) {
      sendLoggingEvents(TrackingEvents.PROVIDER_SESSION_EARLY_END);
      setIsEarlyEndModalOpen(true);
    } else {
      handleCompleteSession();
    }
  }, [checkShouldShowEarlyEndModal, handleCompleteSession]);

  const handleModalOnComplete = useCallback(() => {
    handleCompleteSessionEarly();
    setIsEarlyEndModalOpen(false);
  }, [handleCompleteSessionEarly]);

  return (
    <>
      <EndSessionButton onClick={handleButtonPress} aria-label='Complete session'>
        Complete session
      </EndSessionButton>
      <EarlyEndSessionModal
        isOpen={isEarlyEndModalOpen}
        isRestartLoading={isRestartLoading}
        onClose={() => setIsEarlyEndModalOpen(false)}
        onRestart={handleRestartSession}
        onComplete={handleModalOnComplete}
      />
    </>
  );
}
